export const cognitoConfig = {
  UserPoolId: "eu-west-1_GJT9E4omj",
  ClientId: "3rno5ilu49r8cu6qq65lihslo5",
  URL: "https://ypcdl7dr4e.execute-api.eu-west-1.amazonaws.com/v1/"
};